<template>
  <div class="ladging">
    <!-- <header-web /> -->
    <loader-dynamic :src="`header-${$store.state.app.activeGroup.publicPage.layout}`" />
    <div v-if="comps.length == 0" style="min-height: calc(100vh - 408px)"></div>
    <template v-else>
      <loader-web
        :src="comp.st1"
        :comp="comp"
        v-for="(comp, i) in comps"
        :key="i"
        
      />
      <!-- @on-show-task="showTask"
        @on-course-info="courseInfo" -->
    </template>
    <loader-dynamic :src="`footer-${$store.state.app.activeGroup.publicPage.layout}`" />
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
var _ = require("lodash");
const moment = require("moment");

export default {
  components: {
    loaderWeb: () => ({
      component: import("@/views/shuffle/loader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    loaderDynamic: () => ({
      component: import("@/views/shuffle/dynamic"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      comps: [],
      comp: {},
      news: [],
      modal: {
        title: "",
        task: {},
        taskShow: false,
        showCourse: false,
        course: {},
        courseInfos: []
      },
      locationHref: "#",
      contactHref: "#"
    };
  },
  mounted() {
    if (this.$store.state.app.isMobile) {
      this.$router.push({ name: "login" });
    } 
    else this.init(this.$route.params.id);
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init(pageId) {
      //this.toggleBodyClass('removeClass', 'navbar-nav-show');

      this.toggleBodyClass("addClass", "dynamic-locker");
      let _page = this.$store.state.app.pages.filter(x => x.id == pageId);
      if (_page.length > 0) {
        if (_page[0]["locTypeCode"] == "single_content") {
          this.loadSingleContent(_page[0]);
        } else if (_page[0]["locTypeCode"] == "list_content") {
          this.loadListContent(_page[0]);
        } else {
          this.loadComponents(pageId);
        }
        document.title = _page[0].task;
      }
      this.initHeaderTop();
    },
    initHeaderTop() {
      let _location = this.$store.state.app.pages.filter(
        x => x.st1 == "pageLocation"
      );
      if (_location.length) {
        this.locationHref = _location[0].id;
      }

      let _contact = this.$store.state.app.pages.filter(
        x => x.st1 == "pageContact"
      );
      if (_contact.length) {
        this.contactHref = _contact[0].id;
      }
    },
    loadListContent(page) {
      this.comps = [
        {
          st1: "dynamic/title",
          task: page.task
        },
        {
          st1: "dynamic/loc-type-list",
          locTypeId1: page.locTypeId1
        }
      ];
      this.toggleBodyClass("removeClass", "dynamic-locker");
    },
    loadSingleContent(page) {
      this.comps = [
        // {
        //   st1: "dynamic/title",
        //   task: page.task
        // },
        {
          st1: "single-content",
          organizationTaskId: page.organizationTaskId
        }
      ];
      this.toggleBodyClass("removeClass", "dynamic-locker");
    },
    loadComponents(e) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "task/TaskInheritedDetail" },
        params: {
          id: e
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          let compBox = res.data.task.b.filter(x => x.ot == 355);
          if (compBox.length > 0) {
            this.loadBox(compBox[0].id);
          }
        }
      });
    },
    loadBox(boxId) {
      request({
        api: { method: "GET", url: "task/boxInTaskList" },
        params: {
          skip: 0,
          size: 10,
          id: boxId
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log('res.data.tasks', res.data.tasks.filter(x=>x.ord>1000));
          this.comps = _.sortBy(res.data.tasks.filter(x=>x.ord>1000), "ord", "asc");
        }
      });
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.id != oldRoute.params.id) {
        Object.assign(this.$data, this.$options.data());
        this.$nextTick(() => {
          this.init(newRoute.params.id);
        });
      }
    }
  }
};
</script>
